import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import BrandTooltip from 'components/consumer/BrandTooltip';
const ToggleButton = t0 => {
  const $ = _c(57);
  const {
    contentId,
    id,
    isSelected,
    label,
    description,
    onClick,
    size: t1,
    styling,
    infoTooltip,
    infoTooltipContent,
    showCloseButton: t2,
    iconSize: t3
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const showCloseButton = t2 === undefined ? true : t2;
  const iconSize = t3 === undefined ? "small" : t3;
  const isImportantToggle = styling === "ImportantToggle";
  let t4;
  if ($[0] !== isImportantToggle) {
    t4 = classNames("group/ToggleButton items-center flex justify-between relative", {
      "inline-flex": isImportantToggle
    });
    $[0] = isImportantToggle;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = isSelected ? "true" : "false";
  const t6 = !isImportantToggle;
  const t7 = !isSelected && !isImportantToggle;
  const t8 = !isImportantToggle;
  const t9 = !isImportantToggle;
  const t10 = !isSelected && !isImportantToggle;
  const t11 = !isImportantToggle;
  const t12 = !isSelected && !isImportantToggle;
  const t13 = !isSelected && !isImportantToggle;
  const t14 = isSelected && !isImportantToggle;
  const t15 = isSelected && !isImportantToggle;
  const t16 = isSelected && !isImportantToggle;
  const t17 = isSelected && !isImportantToggle;
  const t18 = !isSelected && isImportantToggle;
  const t19 = isSelected && isImportantToggle;
  const t20 = iconSize === "big";
  const t21 = size === "xs";
  const t22 = size === "sm";
  let t23;
  if ($[2] !== isImportantToggle || $[3] !== t10 || $[4] !== t11 || $[5] !== t12 || $[6] !== t13 || $[7] !== t14 || $[8] !== t15 || $[9] !== t16 || $[10] !== t17 || $[11] !== t18 || $[12] !== t19 || $[13] !== t20 || $[14] !== t21 || $[15] !== t22 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t23 = classNames("items-center bg-white border-solid text-gray cursor-pointer flex flex-1 justify-center whitespace-nowrap", {
      "border border-gray-light7": t6,
      "hover:text-gray hover:!bg-gray-light9": t7,
      "group-[:first-child]/ToggleButton:rounded-tl group-[:first-child]/ToggleButton:rounded-bl group-[:last-child]/ToggleButton:rounded-tr group-[:last-child]/ToggleButton:rounded-br": t8,
      "focus:outline-0": t9,
      "focus:!bg-gray-light9": t10,
      "focus-visible:[outline-style:auto] focus-visible:outline-2 focus-visible:outline-brand focus-visible:outline-offset-[-2px]": t11,
      "group-[:not(:first-child)]/ToggleButton:border-l-0 group-[:not(:first-child)]/ToggleButton:pl-[calc(.7rem_+_1px)]": t12,
      "group-[:not(:first-child):hover]/ToggleButton:border-l group-[:not(:first-child):hover]/ToggleButton:-ml-px": t13,
      "border border-brand !bg-brand text-white -ml-px pr-[calc(.7rem_+_1px)]": t14,
      "focus-visible:[outline-style:auto] focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-[-4px]": t15,
      "focus:!bg-brand-dark": t16,
      "hover:!bg-brand-dark": t17,
      "min-h-[48px] inline-block !py-4 !px-0": isImportantToggle,
      "border-b-2": isImportantToggle,
      "focus:border-brand-dark": isImportantToggle,
      "focus-visible:[outline-style:auto] focus-visible:outline-2 focus-visible:outline-brand": isImportantToggle,
      "border-white": t18,
      "border-brand-dark": t19,
      "!m-0": t20,
      "text-xs font-bold px-[.7rem] py-2": t21,
      "text-sm font-bold p-[.7rem]": t22
    });
    $[2] = isImportantToggle;
    $[3] = t10;
    $[4] = t11;
    $[5] = t12;
    $[6] = t13;
    $[7] = t14;
    $[8] = t15;
    $[9] = t16;
    $[10] = t17;
    $[11] = t18;
    $[12] = t19;
    $[13] = t20;
    $[14] = t21;
    $[15] = t22;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t23;
  } else {
    t23 = $[20];
  }
  const t24 = isImportantToggle && !isSelected;
  const t25 = isImportantToggle && isSelected;
  let t26;
  if ($[21] !== isImportantToggle || $[22] !== t24 || $[23] !== t25) {
    t26 = classNames({
      "text-lg font-bold": isImportantToggle,
      "text-gray-light2": t24,
      "text-gray": t25,
      "group-hover/ToggleButton:text-gray": isImportantToggle,
      "group-focus/ToggleButton:text-gray": isImportantToggle
    });
    $[21] = isImportantToggle;
    $[22] = t24;
    $[23] = t25;
    $[24] = t26;
  } else {
    t26 = $[24];
  }
  let t27;
  if ($[25] !== isSelected) {
    t27 = !!isSelected && <VisuallyHidden>- selected</VisuallyHidden>;
    $[25] = isSelected;
    $[26] = t27;
  } else {
    t27 = $[26];
  }
  let t28;
  if ($[27] !== label || $[28] !== t26 || $[29] !== t27) {
    t28 = <span className={t26}>{label}{t27}</span>;
    $[27] = label;
    $[28] = t26;
    $[29] = t27;
    $[30] = t28;
  } else {
    t28 = $[30];
  }
  let t29;
  if ($[31] !== description || $[32] !== isImportantToggle) {
    t29 = description && !isImportantToggle && <span>{description}</span>;
    $[31] = description;
    $[32] = isImportantToggle;
    $[33] = t29;
  } else {
    t29 = $[33];
  }
  let t30;
  if ($[34] !== contentId || $[35] !== id || $[36] !== onClick || $[37] !== t23 || $[38] !== t28 || $[39] !== t29 || $[40] !== t5) {
    t30 = <button aria-controls={contentId} aria-selected={t5} className={t23} id={id} onClick={onClick} role="tab" type="button">{t28}{t29}</button>;
    $[34] = contentId;
    $[35] = id;
    $[36] = onClick;
    $[37] = t23;
    $[38] = t28;
    $[39] = t29;
    $[40] = t5;
    $[41] = t30;
  } else {
    t30 = $[41];
  }
  const t31 = iconSize === "big";
  let t32;
  if ($[42] !== t31) {
    t32 = classNames("items-center cursor-pointer z-[1000] [&_svg]:!m-0", {
      "!top-[calc(50%_-_9px)]": t31
    });
    $[42] = t31;
    $[43] = t32;
  } else {
    t32 = $[43];
  }
  let t33;
  if ($[44] !== iconSize || $[45] !== infoTooltip || $[46] !== infoTooltipContent || $[47] !== showCloseButton) {
    t33 = infoTooltip && <BrandTooltip iconClassName="!top-0" iconSize={iconSize} openOnHover={true} showCloseButton={showCloseButton} title="" width={300}>{infoTooltipContent}</BrandTooltip>;
    $[44] = iconSize;
    $[45] = infoTooltip;
    $[46] = infoTooltipContent;
    $[47] = showCloseButton;
    $[48] = t33;
  } else {
    t33 = $[48];
  }
  let t34;
  if ($[49] !== t32 || $[50] !== t33) {
    t34 = <div className={t32}>{t33}</div>;
    $[49] = t32;
    $[50] = t33;
    $[51] = t34;
  } else {
    t34 = $[51];
  }
  let t35;
  if ($[52] !== id || $[53] !== t30 || $[54] !== t34 || $[55] !== t4) {
    t35 = <div className={t4} key={id}>{t30}{t34}</div>;
    $[52] = id;
    $[53] = t30;
    $[54] = t34;
    $[55] = t4;
    $[56] = t35;
  } else {
    t35 = $[56];
  }
  return t35;
};
ToggleButton.propTypes = {
  contentId: PropTypes.string,
  id: PropTypes.string,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['xs', 'sm']),
  styling: PropTypes.oneOf(['ImportantToggle']),
  infoTooltip: PropTypes.bool,
  infoTooltipContent: PropTypes.string,
  showCloseButton: PropTypes.bool,
  iconSize: PropTypes.string
};
export default ToggleButton;